import React, { PropTypes } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalAlert.scss';
import Button from 'react-bootstrap/lib/Button';

const ModalAlert = ({ title, bodyText, disableButton, name, ...props }) =>
<Modal {...props}>
  <Modal.Header className="bg-warning" closeButton>
    <Modal.Title>{title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {bodyText}
    <br /><br />
    {!disableButton ? (
      <Button className="btn btn-warning pull-right" onClick={() => props.onHide() }>Zamknij</Button>
    ) : null}
    <br /><br />
  </Modal.Body>
</Modal>;

export default withStyles(s)(ModalAlert);



// WEBPACK FOOTER //
// src/components/ModalAlert/ModalAlert.js